import { motion } from "framer-motion";

export default function Hero() {

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.3 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <section
      className="relative w-full min-h-screen overflow-hidden bg-black pt-20"
      aria-label="Solar Panels in Sukkur, Larkana & Quetta - Solidera Energy"
    >

      {/* Background */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `linear-gradient(135deg, #f97a08 0%, rgba(151, 163, 22, 0.1) 100%), 
                            url('../../assets/s1.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent" />
      </div>

      {/* Content */}
      <motion.div
        className="relative z-10 max-w-7xl mx-auto px-6 h-full flex flex-col justify-center py-20"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >

        {/* Badge */}
        <motion.div variants={itemVariants} className="mb-6">
          <span className="text-orange-400 text-sm font-medium">
            ☀️ #1 Solar Company in Sukkur, Larkana & Quetta
          </span>
        </motion.div>

        {/* SEO H1 */}
        <motion.h1
          variants={itemVariants}
          className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight"
        >
          Professional Complete Solar Solution Services in Sukkur, Larkana and Quetta
          <br />
          <span className="bg-gradient-to-r from-orange-400 to-yellow-400 bg-clip-text text-transparent">
            Save Up to 90% Electricity Bills
          </span>
        </motion.h1>

        {/* SEO Paragraph */}
        <motion.p
          variants={itemVariants}
          className="text-lg text-white/70 mb-8 max-w-2xl"
        >
          Solidera Energy provides affordable solar panel installation in Sukkur, Larkana & Quetta. 
          Get complete solar systems, net metering, inverter & battery solutions with expert service.
        </motion.p>

        {/* CTA */}
        <motion.div variants={itemVariants} className="flex gap-4 mb-10">

          <a
            href="tel:+923337111075"
            className="px-6 py-3 bg-white text-black font-bold rounded-lg"
          >
            📞 Call Now
          </a>

          <a
            href="https://wa.me/923337111075"
            target="_blank"
            className="px-6 py-3 bg-orange-500 text-black font-bold rounded-lg"
          >
            💬 WhatsApp
          </a>

        </motion.div>

        {/* Trust */}
        <motion.div variants={itemVariants} className="flex gap-6 text-white/60 text-sm">
          <span>✔ 2000+ Installations</span>
          <span>✔ Sukkur Experts</span>
          <span>✔ Larkana Experts</span>
          <span>✔ Quetta Experts</span>
          <span>✔ Warranty Included</span>
        </motion.div>

      </motion.div>
    </section>
  );
}